export var buildPath = function (input, basePath) {
    var base = basePath || "";
    var p = "" + base + (base.endsWith("/") || !input ? "" : "/") + (input || "");
    var prefix = p.startsWith("/") ? "" : "/";
    return "" + prefix + p;
};
export var resolveFullPath = function (path, basePath) {
    //
};
